import { camelCase } from "../../utils/stringUtilHelper";

const getQuickLinkTextSource = (value, modularContent) => {
  let tmpValue = value;
  const objects = value.match(/<object.*?><\/object>/g);

  if (objects) {
    objects.forEach((object) => {
      let codename = object.match(/codename=".*?"/g);
      codename = codename && codename.length > 0 ? codename[0] : null;

      if (codename) {
        codename = codename.substring(codename.indexOf("\"") + 1, codename.lastIndexOf("\""));
        const tmpContent = modularContent.find((content) => content.internal.type === "kontent_item_faq_section" && content.system.codename === codename);

        if (tmpContent) {
          const title = `<h3 id="${camelCase(tmpContent.elements.title.value)}">${tmpContent.elements.title.value}</h3>`;
          tmpValue = tmpValue.replace(object, title);
        }
      }
    });
  }

  return tmpValue;
};

export default getQuickLinkTextSource;
